import SLSRegraClient from '@/api/SistemaDKP/sls-regra.client';

import { ErrorMessage } from '@/libs/Error';

export default class SLSRegraService {
  constructor() {
    this.client = new SLSRegraClient();
    this.error = new ErrorMessage();
  }

  async index(queries) {
    try {
      const { data } = await this.client.index(queries);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao listar as regras');
    }
  }

  async findByTipoRegra(regratipoid) {
    try {
      const { data } = await this.client.index(regratipoid);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao listar os regra');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.client.store(data);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao criar regra');
    }
  }

  async show(id) {
    try {
      const { data } = await this.client.show(id);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao buscar regra');
    }
  }

  async update(data) {
    try {
      const { data: response } = await this.client.update(data);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao atualizar regra');
    }
  }

  async destroy(id) {
    try {
      const { data: response } = await this.client.destroy(id);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao deletar regra');
    }
  }
}
